import { ref, watchEffect } from 'vue'
import { defineStore } from 'pinia'
import { generalStore } from './index.js';

export const radioStore = defineStore('radio', () => {
    const store = generalStore();
    const route = store.route;
    const URL_RADIO = import.meta.env.VITE_URL_RADIO;

    var radio = new Audio(URL_RADIO)
    var vol = ref(0)

    const getVol = () => {
        return vol.value;
    }

    const setVol = (data) => {
        if (data != null || data != undefined) {
            radio.volume = (data / 100);
            vol.value = data;
            store.setLocalStorage("persistVol", vol.value);
        } else {
            store.setLocalStorage("persistVol", vol.value);
        }
    }

    const setLoad = () => {
        radio.load();
    }

    if (route.name == 'Radio') {
        setLoad();
    }

    /**
    * Function used to pause radio playback
    */
    const setPause = () => {
        radio.pause();
        store.setIsLive(false);
    }

    /**
    * Function used to start radio playback
    */
    const setPlay = () => {
        radio.play();
        store.setIsLive(true);
    }

    watchEffect(() => {
        if (route.name != 'Radio') {
            setPause();
        }
    })

    return {
        getVol,
        setVol,
        setPause,
        setPlay,
        setLoad
    }
})